import PageTitle from '../components/CommonComps/Titles/PageTitle';
import ShowAllPackages from '../components/PackagesComps/ShowAllPackages';

const Packages = () => {
  // rendering packages page component here
  return (
    <>
      <PageTitle title='Packages' />

      <ShowAllPackages />
    </>
  );
};

export default Packages;
